module.exports = __webpack_public_path__ + "img/icons-complaint.7d56e4fd.svg";